import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "back",
  "use": "back-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"back\"><path fill-rule=\"evenodd\" d=\"M4.115 10 11 15.594V17L2 9.5 11 2v1.406L4.115 9H17v1H4.115Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol